import React from "react";
import PaletteCouleursAffichageToutes from "../../../../boiteAOutils/PaletteCouleursAffichageToutes";

// Styles prédéfinis
const predefinedStyles = {
    Body: {fontSize: 16, fontWeight: "normal", fontStyle: "normal"},
    Remarque: {fontSize: 16, fontWeight: "normal", fontStyle: "italic"},
    Titre: {fontSize: 60, fontWeight: "bold", fontStyle: "normal"},
    "Heading 1": {fontSize: 48, fontWeight: "bold", fontStyle: "normal"},
    "Heading 2": {fontSize: 36, fontWeight: "bold", fontStyle: "normal"},
    "Heading 3": {fontSize: 28, fontWeight: "bold", fontStyle: "normal"},
    "Heading 4": {fontSize: 20, fontWeight: "bold", fontStyle: "normal"}
};

const defaultFonts = [
    "Arial",
    "Consolas",
    "Courier New",
    "Garamond",
    "Georgia",
    "Helvetica",
    "Lucida Console",
    "Sofia Pro",
    "Tahoma",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana"
];
const SidebarTextSettings = ({setSidebarVisible, textSettings, setTextSettings}) => {

    const [style, setStyle] = React.useState("Body");
    const {fontSize, fontWeight, fontStyle, fontFamily, color, backgroundColor} = textSettings;


// Trouver le style correspondant aux attributs
    const getStyleFromAttributes = (fontSize, fontWeight, fontStyle) => {
        for (const [name, attributes] of Object.entries(predefinedStyles)) {
            if (
                attributes.fontSize === fontSize &&
                attributes.fontWeight === fontWeight &&
                attributes.fontStyle === fontStyle
            ) {
                return name;
            }
        }
        return "Personnalisé";
    };

    React.useEffect(() => {
        const computedStyle = getStyleFromAttributes(fontSize, fontWeight, fontStyle);
        setStyle(computedStyle);
    }, [fontSize, fontWeight, fontStyle]);

    const handleChangeStyle = (e) => {
        const selectedStyle = e.target.value;
        setStyle(selectedStyle);

        const attributes = predefinedStyles[selectedStyle];
        if (attributes) {
            setTextSettings(prev => ({
                ...prev,
                fontSize: attributes.fontSize,
                fontWeight: attributes.fontWeight,
                fontStyle: attributes.fontStyle
            }));
        }
        // Si "Personnalisé" : ne rien changer
    };

    const handleChangeSize = (e) => {
        const size = Number(e.target.value);
        setTextSettings(prev => ({...prev, fontSize: size}));

        const computedStyle = getStyleFromAttributes(size, fontWeight, fontStyle);
        setStyle(computedStyle);
    };


    return (
        <>
            <div className="sidebar-titre">
                Texte
                <button onClick={() => setSidebarVisible(false)} className="toggle-button">
                    X
                </button>
            </div>

            <div className="sidebar-section">Style</div>
            <div className="sidebar-choix">
                <div className="libelle">Style</div>
                <select onChange={handleChangeStyle} value={style}>
                    {Object.keys(predefinedStyles).map((styleName) => (
                        <option key={styleName} value={styleName}>{styleName}</option>
                    ))}
                    <option value="Personnalisé">Personnalisé</option>
                </select>
            </div>

            <div className="sidebar-choix">
                <div className="libelle">Taille</div>
                <select onChange={handleChangeSize} value={textSettings.fontSize}>
                    {[12, 16, 18, 20, 24, 28, 32, 36, 40, 48, 60, 72, 90].map((size) => (
                        <option key={size} value={size}>
                            {size}px
                        </option>
                    ))}
                </select>
            </div>

            <div className="sidebar-choix">
                <div className="libelle">Typo</div>
                <select onChange={(e) => setTextSettings(prev => ({...prev, fontFamily: e.target.value}))}
                        value={fontFamily}>
                    {defaultFonts.map((font) => (
                        <option key={font} value={font} style={{fontFamily: font}}>
                            {font}
                        </option>
                    ))}
                </select>
            </div>

            <div className="sidebar-choix">
                <div className="libelle">Format</div>
                <select
                    value={`${fontWeight}-${fontStyle}`}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value === "normal-normal") {
                            setTextSettings(prev => ({...prev, fontWeight: "normal", fontStyle: "normal"}));
                        } else if (value === "bold-normal") {
                            setTextSettings(prev => ({...prev, fontWeight: "bold", fontStyle: "normal"}));
                        } else if (value === "normal-italic") {
                            setTextSettings(prev => ({...prev, fontWeight: "normal", fontStyle: "italic"}));
                        } else if (value === "bold-italic") {
                            setTextSettings(prev => ({...prev, fontWeight: "bold", fontStyle: "italic"}));
                        }
                    }}
                >
                    <option value="normal-normal">Normal</option>
                    <option value="bold-normal">Gras</option>
                    <option value="normal-italic">Italique</option>
                    <option value="bold-italic">Gras + Italique</option>
                </select>
            </div>

            <div className="sidebar-section">Couleur du texte</div>
            <PaletteCouleursAffichageToutes
                defaultColor={color}
                onColorChange={(newColor) => setTextSettings(prev => ({...prev, color: newColor}))}
            />

            <div className="sidebar-section">Fond du texte</div>
            <PaletteCouleursAffichageToutes
                defaultColor={backgroundColor}
                onColorChange={(newColor) => setTextSettings(prev => ({...prev, backgroundColor: newColor === "transparent" ? '' : newColor}))}
                showTransparent={true}
            />
        </>
    );
};

export default SidebarTextSettings;
